(function() {

	"use strict";

	angular
		.module("ATMGurus")
		.filter('capitalize', capitalize);

	function capitalize() {

		return function(string, scope) {
			if (! string) return;
			return string.split(' ')
				.map(function(word){
					return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
				})
				.join(' ')
		}

	}

})()


// WEBPACK FOOTER //
// ./src/app/filters/capitalize.js